module.exports = new __parcel__URL__("panda.0b0047af.svg").toString();